import React, { useState } from "react";
import { Row, Col, Accordion, Card } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { ClockHistory } from "react-bootstrap-icons";
import MobileViewOperatorOfCaneled from "../CanceledOrder/components/BasketItems/ModalUpdatePersonInItemsCanceled/MobileViewOperatorOfCaneled";
import MobileViewOfWaranty from "../Orders/components/MobileViewOfWaranty";
import MobileViewOfrequestOfCancle from "../Orders/components/BasketItems/operatorUpdatePersonItemsCanceled/MobileViewOfrequestOfCancle";
import HistoryOfTransactionsMobile from "../Orders/components/BasketItems/operatorUpdatePersonItemsCanceled/HistoryOfTransactionsMobile";
import SelectComponent from "./ReactSelectComponent";
import _ from "lodash";

function MobileView(props) {
  const { control, getValues } = useFormContext()
  let showPrice = Intl.NumberFormat("en-US");
  const [inputList, setInputList] = useState([]);
  const handleCancelStatusChange = (event) => {
    const selectedValue = event.target.value;

    // زمانی که گزینه خاص انتخاب شد، پیام را نمایش می‌دهیم
    if (selectedValue === 4) {
      props.updateCancelStatusChangeFromChild(true, 8);
    } else {
      props.updateCancelStatusChangeFromChild(false, 0);
    }
  };

  return (
    <>
      {/* اگر مدیریت عملیات انتخاب شده باشد لیست انتخاب وضعیت کنسلی نمایش داده میشود */}
      {(props?.typeOfModal === "CancelStatus" || props?.typeOfModal === "SupplierCancelStatus") &&
        props?.type == "operatorOfCaneled" && (
          <Row>
            dsfdsfdsf
            <Col xs="12" sm="7" lg="7">
              <Controller
                name="canceledstatus"
                control={props?.control}
                //rules={{ required: true }}
                render={({ field }) => (
                  <SelectComponent
                    className="w-100 mt-4"
                    placeholder="انتخاب وضعیت"
                    options={props?.listType?.map(item => ({ value: item.id, label: item.title, color: item.id === 4 ? "red" : "" }))}
                    field={field}
                    onChange={(newValue) => {
                      handleCancelStatusChange(newValue); // برای نشان دادن پیام
                      field.onChange(newValue)
                    }
                    }
                  />
                )}
              />
              {/* {errors.canceledstatus && <span>لطفا یکی از وضعیت ها را انتخاب نمایید</span>} */}
            </Col>
          </Row>
        )}

      {/* اگر درخواست پرداخت یا دریافت از گارانتی باشد،لیست آژانسها در بالای مدال نمایش داده میشود */}
      {props.type == "waranty" && props?.data?.succeeded && (
        <>
          <Row>
            <Col lg="6" xl="6" className="mx-xl-auto">
              <Controller
                name="agencySelectedId"
                control={control}
                rules={{}}
                render={({ field }) => (
                  <SelectComponent
                    className="mt-0"
                    placeholder="شرکت تامین کننده"
                    options={props.agency?.map(item => ({ value: item.id, label: item.companyName }))}
                    field={field}
                  />
                )}
              />
            </Col>

            {/* <Col lg="3" xl="6" className="my-3 d-flex">
              <div className="mt-1 mx-1">
                {" "}
                <input
                  type="checkbox"
                  onChange={() => {
                    props.setShowAgencyAccount(!props.showAgencyAccount);
                  }}
                />{" "}
              </div>
              <div className="mx-1">
                {" "}
                <label>پرداخت نقدی</label>
              </div>
            </Col> */}
          </Row>
          {/* {props.showAgencyAccount && (
            <>
              <Row>
                <Col className="mb-3" xs="12" md="6" xl="6">
                  <Controller
                    name="sourceAccountId"
                    control={control}
                    rules={{}}
                    render={({ field }) => (
                      <SelectComponent
                        className="mt-0"
                        placeholder="حساب مبدا"
                        options={props.typeOfModalWaranty == "payToWaranty" ?
                          props.sammaneh?.map(item => ({ value: item.id, label: (item?.cardNumber || "")?.replace(/\d(?=\d{4})/g, "*") + " - " + item?.cardOwnerName })) :
                          props.agency?.map(item => {
                            if (getValues("agencySelectedId")?.value == item.id) {
                              if (_.isEmpty(item?.accounts))
                                return { value: 0, label: "حسابی برای این آژانس وجود ندارد" };
                              else
                                return item.accounts.map((account) => {
                                  return account.accountCards.map((accountCard) => {
                                    return (
                                      { value: accountCard?.accountId, label: accountCard?.cardNumber.replace(/\d(?=\d{4})/g, "*") + " - " + accountCard?.cardOwnerName }

                                    );
                                  });
                                });
                            }
                          })
                        }
                        field={field}
                      />
                    )}
                  />
                </Col>
                <Col className="mb-3" xs="12" md="6" xl="6">
                  <Controller
                    name="destinationAccountId"
                    control={control}
                    rules={{}}
                    render={({ field }) => (
                      <SelectComponent
                        className="mt-0"
                        placeholder="حساب مقصد"
                        options={props.typeOfModalWaranty != "payToWaranty" ?
                          props.sammaneh?.map(item => ({ value: item.id, label: (item?.cardNumber || "")?.replace(/\d(?=\d{4})/g, "*") + " - " + item?.cardOwnerName })) :
                          props.agency?.map(item => {
                            if (getValues("agencySelectedId")?.value == item.id) {
                              if (_.isEmpty(item?.accounts))
                                return { value: 0, label: "حسابی برای این آژانس وجود ندارد" };
                              else
                                return item.accounts.map((account) => {
                                  return account.accountCards.map((accountCard) => {
                                    return (
                                      { value: accountCard?.accountId, label: accountCard?.cardNumber.replace(/\d(?=\d{4})/g, "*") + " - " + accountCard?.cardOwnerName }

                                    );
                                  });
                                });
                            }
                          })
                        }
                        field={field}
                      />
                    )}
                  />
                </Col>
              </Row>
            </>
          )} */}
        </>
      )}
      {props?.data?.data?.map((item, key) => {
        inputList.push({
          id: item.id,
          priceIsLock: true,
          dateIsLock: true,
          timeIsLock: true,
          basketItemId: item.basketItemId,
        });
        return (
          <div className="bg-light border rounded  my-2" key={key}>
            <Accordion>
              <Row className="px-3 mt-2 align-items-center">
                <Col>
                  <h3 className="mb-0 ml-2">{item.basketItemAmusementServiceName}</h3>
                </Col>
                <Col xs="auto" className="d-flex justify-content-end">
                  <Accordion.Header className="btn " variant="link">
                    <ClockHistory color="#767885" size={15} />
                  </Accordion.Header>
                </Col>
              </Row>
              <Row className="pt-3 pb-0 px-4">
                {/* نام فیلدها  */}
                <Col xs={6} className="px-0">
                  {" "}
                  {props?.titles?.map((title, key) => {
                    return (
                      <Col
                        key={key}
                        className={
                          props.type == "waranty" && key > 2
                            ? "my-5 py-1 font-weight-bold"
                            : props?.type == "operatorOfCaneled" && key > 5
                              ? "my-4 py-1  font-weight-bold ps-0"
                              : "my-2 font-weight-bold ps-0"
                        }
                      >
                        {" "}
                        {title.name} :
                      </Col>
                    );
                  })}{" "}
                </Col>
                {
                  // کنسلی درخواست
                  props.type == "requestOfCancle" ? (
                    <MobileViewOfrequestOfCancle
                      item={item}
                      showPrice={showPrice}
                      errors={props?.errors}
                      control={props?.control}
                      reasonList={props?.reasonList}
                      inputOnChange={props?.inputOnChange}
                    />
                  ) : //دریافت یا پرداخت گارانتی
                    props.type == "waranty" ? (
                      <MobileViewOfWaranty
                        item={item}
                        showPrice={showPrice}
                        errors={props?.errors}
                        control={props?.control}
                        inputList={inputList}
                        setValue={props?.setValue}
                        inputOnChange={props?.inputOnChange}
                      />
                    ) : (
                      //مدیریت عملیات کنسلی
                      <MobileViewOperatorOfCaneled
                        item={item}
                        showPrice={showPrice}
                        errors={props?.errors}
                        control={props?.control}
                        inputList={props.inputListStatusOfcancel}
                        setValue={props?.setValue}
                        typeOfModal={props?.typeOfModal}
                      />
                    )
                }
              </Row>

              {/* transactions */}
              <Accordion.Body>
                <Card.Body className="px-0 pt-0">
                  <HistoryOfTransactionsMobile item={item} itemtransactions={item.transactions} typeOfModalWaranty={props.typeOfModalWaranty} />
                </Card.Body>
              </Accordion.Body>
            </Accordion>
          </div>
        );
      })}
      <Row className=" mx-1">
        <Controller
          name="description"
          control={props?.control}
          render={({ field: { onChange, value } }) => (
            <TextField
              id="description"
              className="w-100 mt-2 bg-white"
              variant="outlined"
              type="text"
              rows={7}
              multiline
              //style={textField}
              placeholder="توضیحات"
              value={value}
              onInput={onChange}
              sx={{
                ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                  padding: "8.5px 14px 8.5px 0px !important",
                }
              }}
            />
          )}
        />
      </Row>
    </>
  );
}

export default MobileView;
